import request from '@/utils/request';
import { datasetEndpoint } from '@/constants/urls';

const status = (code) => request({
  method: 'GET',
  url: `${datasetEndpoint(code)}/status`,
});

const DatasetStatusService = {
  status,
};

export default DatasetStatusService;
